// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","content":"Footer_content__tUe-I"};